import { useEffect } from 'react';

interface KeyboardShortcut {
  key: string;
  ctrl?: boolean;
  cmd?: boolean;
  shift?: boolean;
  callback: () => void;
}

/**
 * Hook pour gérer les raccourcis clavier
 */
export const useKeyboardShortcut = (shortcuts: KeyboardShortcut[]) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      shortcuts.forEach(({ key, ctrl, cmd, shift, callback }) => {
        const ctrlPressed = ctrl ? event.ctrlKey : true;
        const cmdPressed = cmd ? event.metaKey : true;
        const shiftPressed = shift ? event.shiftKey : true;
        
        const modifiersMatch = (!ctrl || ctrlPressed) && 
                               (!cmd || cmdPressed) && 
                               (!shift || shiftPressed);
        
        if (event.key.toLowerCase() === key.toLowerCase() && modifiersMatch) {
          // Si c'est Cmd+K ou Ctrl+K, empêcher le comportement par défaut du navigateur
          if ((ctrl || cmd) && key.toLowerCase() === 'k') {
            event.preventDefault();
          }
          callback();
        }
      });
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [shortcuts]);
};
